module.exports = __webpack_public_path__ + "static/media/hero_img_homepage.55257e76.png";